<div class="availability-section">
  <div class="availability-section__status">
    <span class="availability-section__label">
      {{ 'inventory.availability.currentStatus' | translate }}
    </span>
    <span class="availability-section__value">
      {{ currentStatus() | translate }}
    </span>
  </div>

  <div class="availability-section__table-container" [formGroup]="availabilityForm">
    <table mat-table [dataSource]="dataFormSource()" class="availability-table">
      @for (column of tableColumns; track column.key) {
        <ng-container [matColumnDef]="column.key">
          <th mat-header-cell *matHeaderCellDef class="table-header">
            {{ column.label | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="table-cell">
            @if (column.readonly) {
              <div class="readonly-value">
                {{ row[column.key] }}
              </div>
            } @else if (column.editable) {
              <mat-form-field appearance="outline" class="input-field">
                <input matInput type="number" [formControlName]="column.key" min="0" />
              </mat-form-field>
            } @else {
              {{ row[column.key] }}
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
